<div class="ou-wrap">
  <button
    type="button"
    class="ou-btn"
    data-tour="online-users"
    (click)="toggle($event)"
    aria-label="Compañeros en línea"
    title="Compañeros en línea"
  >
    <fa-icon [icon]="faUser"></fa-icon>
    <span class="ou-count">{{ others.length > 99 ? '99+' : others.length }}</span>
  </button>

  <div class="ou-dropdown" *ngIf="open" (click)="$event.stopPropagation()">
    <div class="ou-head">
      <span class="ou-dot"></span>
      <span class="ou-title">En línea ahora ({{ others.length }})</span>
    </div>

    <div class="ou-list" *ngIf="others.length > 0; else empty">
      <div class="ou-item" *ngFor="let u of others">
        <div class="ou-avatar-wrap">
          <img class="ou-avatar" [src]="avatarUrl(u)" [alt]="u.displayName" />
          <span *ngIf="getUserLevel(u) as lvl" class="ou-level-badge" [title]="lvl.name">{{ lvl.icon }}</span>
        </div>
        <span class="ou-name">{{ u.displayName }}</span>
        <span class="ou-busy" *ngIf="u.inGame">Jugando</span>
      </div>
    </div>
    <ng-template #empty>
      <p class="ou-empty">Nadie más está en línea por ahora.</p>
    </ng-template>
  </div>
</div>
